var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Hours',{class:_vm.pacingClass,attrs:{"hours":_vm.seat.units_fulfilled,"mantissa":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }